export { Timestamp } from '@angular/fire/firestore';